import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { UploadImageResponse } from './models';

const imageUploadModalService = {
  uploadImage(payload: FormData): Promise<CommonResponse<UploadImageResponse>> {
    const url = '/upload-image';
    return axiosClient.put(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default imageUploadModalService;
